import * as React from 'react';

import * as styles from './styles.css';

interface IAdvantageProps {
  index: number;
  title: string;
  text: string;
}

export function Advantage({ index, title, text }: IAdvantageProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['index']}>{index}</div>
      <div className={styles['content']}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
}
